import React, { useMemo } from "react"
import { Form as FForm } from "react-final-form"
import FormRow from "@/components/blocks/FormRow"
import { TutorField } from "../fields/tutor"
import { FieldNames, positionTypes } from "./constants"
import { DateRangeFields } from "@/components/fields"
import useViewport from "@/hooks/useViewport"
import { setFieldData } from "@/helpers/forms"
import { FormActionButtons } from "../buttons"
import { NumberField, RadioField } from "../fields"
import { validateConnectionFormSubmit } from "../validators"

export const ConnectionForm = ({
  initialValues,
  multipleValues = {},
  showTutorField,
  showPositionField,
  validate,
  loading,
  rowsClassName = "",
  buttonsClassName = "",
  onSubmit,
  onCancel,
  children,
}) => {
  const { isPhoneViewport, isTabletViewport } = useViewport()
  const isMobile = useMemo(() => isPhoneViewport || isTabletViewport, [isPhoneViewport, isTabletViewport])

  return (
    <FForm initialValues={initialValues} onSubmit={onSubmit} validate={validate} mutators={{ setFieldData }}>
      {({ pristine, handleSubmit, values, invalid }) => {
        const isSubmitDisabled = validateConnectionFormSubmit(values, loading, invalid, pristine)

        return (
          <form onSubmit={handleSubmit}>
            <div className={rowsClassName}>
              {showTutorField ? (
                <FormRow label="Tutor" ColProps={{ lg: 13 }} LabelProps={{ className: "v-2", lg: 6 }} className="m-0">
                  <TutorField name={FieldNames.Tutor} />
                </FormRow>
              ) : null}

              {showPositionField && (
                <FormRow
                  label="Tutoring type"
                  ColProps={{ lg: 13 }}
                  LabelProps={{ className: "v-2", lg: 6 }}
                  className="m-0"
                >
                  <RadioField name={FieldNames.Position} options={positionTypes} values={values} />
                </FormRow>
              )}

              <FormRow
                label="Date range"
                ColProps={{ lg: 13 }}
                LabelProps={{ className: "v-2", lg: 6 }}
                className="m-0"
              >
                <DateRangeFields
                  showLabels={false}
                  startPlaceholder={multipleValues[FieldNames.StartDate] ? "Multiple values" : "Date"}
                  endPlaceholder={multipleValues[FieldNames.StartDate] ? "Multiple values" : "Date"}
                />
              </FormRow>

              <FormRow
                label="Paid no shows"
                ColProps={{ lg: 6 }}
                LabelProps={{ className: "v-2", lg: 6 }}
                className="m-0"
              >
                <NumberField name={FieldNames.MaxPaidNoShows} multipleValues={multipleValues} defaultValue={10} />
              </FormRow>

              <FormRow label="Rate" ColProps={{ lg: 6 }} LabelProps={{ className: "v-2", lg: 6 }} className="m-0">
                <NumberField name={FieldNames.Rate} defaultValue={10} multipleValues={multipleValues} isDecimal />
              </FormRow>
            </div>

            <div className={buttonsClassName}>
              {children}
              <FormActionButtons
                onCancel={onCancel}
                isSubmitDisabled={isSubmitDisabled}
                isMobile={isMobile}
                loading={loading}
              />
            </div>
          </form>
        )
      }}
    </FForm>
  )
}
